/** Published pricing overview; not an account-specific billing summary. */
import { Check, Calendar, Sparkles, Palette, BarChart3, Users, ShieldCheck } from "lucide-react";
import "./subscriptionAthletic.css";

const FEATURES = [
  { text: "Unlimited programs and staff", icon: Users },
  { text: "Registration and payments", icon: BarChart3 },
  { text: "League, tournament, and scheduling tools", icon: Calendar },
  { text: "AI-powered features", icon: Sparkles },
  { text: "Custom branding and Website Pro", icon: Palette },
];

const SubscriptionTab = () => (
  <section className="subscription-athletic" data-testid="subscription-tab" aria-labelledby="subscription-plan-heading">
    <div className="subscription-plan">
      <header className="subscription-plan-header">
        <div>
          <p className="subscription-plan-label">Sporthouse</p>
          <h2 id="subscription-plan-heading">Pricing overview</h2>
          <p>This overview describes standard pricing and features, not your organization’s current plan, charges, or access.</p>
        </div>
        <ShieldCheck aria-hidden="true" />
      </header>

      <div className="subscription-plan-body">
        <div className="subscription-rate">
          <p className="subscription-rate-line">
            <strong>5%</strong>
            <span>per successful transaction</span>
          </p>
          <p>The published standard rate is 5% per successful transaction, including payment processing.</p>
          <p className="subscription-current"><Check aria-hidden="true" /> Published standard pricing</p>
        </div>

        <ul className="subscription-features">
          {FEATURES.map(({ text, icon: Icon }) => (
            <li key={text}>
              <Icon aria-hidden="true" />
              <span>{text}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>

    <div className="subscription-explainer">
      <h3>Your billing terms</h3>
      <div>
        <p>Your organization’s billing terms may differ, including any legacy subscription terms.</p>
        <p>View billing records and manage the organization’s default payment method and invoice auto-pay in Sporthouse Billing.</p>
      </div>
    </div>
  </section>
);

export default SubscriptionTab;
